import CloseIcon from "@mui/icons-material/Close";
import {
 Alert,
 Box,
 Button,
 IconButton,
 Modal,
 Stack,
 Typography,
 styled,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import axios from "axios";
import { AlignmentType, Document, HeadingLevel, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { VscFeedback } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";
import "../ApprovalComponent/ApproverMailGeneration.css";
import FeedbackForm from "../ApprovalComponent/FeedbackForm";
import { baseURL } from "../Constant";
const theme = createTheme({
 typography: {
  fontFamily: "Graphik-Regular",
 },
 typography: {
  subtitle1: {
   fontFamily: "Graphik-Medium",
  },
 },
});
const CustomButton = styled(Button)(({ theme }) => ({
 color: "#A814FF",
 textTransform: "none",
 backgroundColor: "white",
 borderRadius: "5px",
 padding: "5px 20px 5px 20px",
 fontWeight: "600",
 fontSize: "18px",
 "&:hover": {
  backgroundColor: "white",
 },
}));

const MyContentMailGeneration = ({
 setL2,
 selectedMail,
 setSelectedMail,
 uniqueID,
 setActiveScreen,
 status,
 program,
 type,
 campaignId,
}) => {
 const [isEditing, setIsEditing] = useState(false);
 const [open, setOpen] = useState(false);
 const [isLoading, setIsloading] = React.useState(false);
 const dispatch = useDispatch();
 const [isUpdated, setIsUpdated] = React.useState(null);
 const isIdNull = useSelector((state) => state.approver.isIdNull);
 //feedback modal
 const [openModal, setOpenModal] = useState(false);
 const [isFeedbackSuccess, setIsFeedbackSuccess] = useState(null);
 const handleCloseModal = () => {
  setOpenModal(false);
 };

 useEffect(() => {
  // Add or remove the blur class based on the modal state
  const body = document.body;
  if (open) {
   body.classList.add("blur-background");
  } else {
   body.classList.remove("blur-background");
  }
  return () => {
   body.classList.remove("blur-background"); // Clean up class on component unmount
  };
 }, [open]);

 useEffect(() => {
  setTimeout(() => {
   setIsFeedbackSuccess(null);
  }, 4000);
 }, [isFeedbackSuccess]);

 const handleTextClick = () => {
  setIsEditing(true);
 };
 function handleRegeneration(userquery) {
  console.log("");
  setIsloading(true);

  let values = {
   currentContent: selectedMail,
   userquery: userquery,
   sessionID: localStorage.getItem("sessionId"),
  };
  axios
   .post(`${baseURL}/fetchresponse`, { values })
   .then((response) => {
    // then print response status
    setSelectedMail(response.data);
    // console.log("responseis", response.data);
    setIsloading(false);
   })
   .catch((err) => {
    // then print response status
    console.error("upload fail", err);
    setIsloading(false);
   });
 }
 const downloadWordDocument = async () => {
  try {
   const doc = new Document({
    sections: [
     {
      properties: {},
      children: convertMarkdownToParagraphs(selectedMail),
     },
    ],
   });

   const blob = await Packer.toBlob(doc);
   if (type == "Teaser") {
    saveAs(blob, `${type}.docx`);
   } else {
    saveAs(blob, `${program}_${type}.docx`);
   }
  } catch (error) {
   console.error("Error generating document:", error);
  }
 };
 const convertMarkdownToParagraphs = (markdown) => {
  const lines = markdown.split("\n");
  return lines.map((line) => {
   const cleanedLine = line.replace(/\*\*/g, "");

   if (cleanedLine.startsWith("# ")) {
    return new Paragraph({
     children: [
      new TextRun({
       text: cleanedLine.replace("# ", ""),

       font: "Aptos", // Font family
      }),
     ],
     heading: HeadingLevel.HEADING_1,
     alignment: AlignmentType.LEFT,
    });
   } else if (cleanedLine.startsWith("## ")) {
    return new Paragraph({
     children: [
      new TextRun({
       text: cleanedLine.replace("# ", ""),

       font: "Aptos", // Font family
      }),
     ],
     heading: HeadingLevel.HEADING_2,
     alignment: AlignmentType.LEFT,
    });
   } else if (cleanedLine.startsWith("- ")) {
    return new Paragraph({
     children: [
      new TextRun({
       text: cleanedLine.replace("- ", ""),
       font: "Aptos", // Font family
      }),
     ],
     bullet: { level: 0 },
    });
   } else if (cleanedLine.startsWith("**")) {
    return new Paragraph({
     children: [
      new TextRun({
       text: cleanedLine,
       font: "Aptos", // Font family
      }),
     ],
    });
   } else if (cleanedLine.startsWith("📢 ")) {
    return new Paragraph({
     children: [new TextRun({ text: cleanedLine, font: "Aptos" })],
    });
   } else {
    return new Paragraph({
     children: [
      new TextRun({
       text: cleanedLine,
       font: "Aptos", // Font family
      }),
     ],
    });
   }
  });
 };

 return (
  <>
   <ThemeProvider theme={theme}>
    {/* <Stack sx={{ alignItems: "center" }}> */}
    {/* <Stack
      sx={{
       borderBottom: "1px solid #b5c1e7",
       width: "97%",
       height: "50px",
       justifyContent: "center",
      }}
     >
      <Stack direction={"row"} justifyContent={"space-between"} sx={{}}>
       <Stack direction={"row"} spacing={0.5}>
        <Typography variant="subtitle1">
         My Content <span>{">"}</span>
        </Typography>

        <Typography
         sx={{
          fontFamily: "Grpahik-Bold !importanrt",
          fontWeight: "600",
         }}
         variant="subtitle1"
        >
         AI Generated Content
        </Typography>
       </Stack>

       <WelcomeName />
      </Stack>
     </Stack> */}
    <Stack
     sx={{
      height: "500px",
      margin: "25px 0px 30px 20px",
      position: "relative",
      width: "100%",
     }}
    >
     {selectedMail != null && (
      <Stack className="disable-selection" spacing={2} sx={{ height: "500px" }}>
       <style>
        {`
                      .highlight {
                          font-weight: bold;
                          color: black;
                      }
                  `}
       </style>
       <div
        style={{
         overflowY: "scroll",
         height: "500px",
         border: "0px !important",
        }}
       >
        <Markdown
         options={{
          overrides: {
           p: {
            props: {
             style: {
              fontSize: "14px",
              fontFamily: "Graphik-Regular",
             },
            },
           },
           li: {
            props: {
             style: {
              fontSize: "14px",
              fontFamily: "Graphik-Regular",
             },
            },
           },
          },
         }}
        >
         {selectedMail}
        </Markdown>
       </div>
      </Stack>
     )}

     <Stack direction={"row"}>
      <CustomButton
       sx={{ paddingBottom: "40px" }}
       onClick={() => {
        setActiveScreen("default");
        setL2("");
       }}
      >
       <img
        style={{ width: "60px" }}
        src={process.env.PUBLIC_URL + "/Images/ApprovalPage/backbutton.png"}
       ></img>
      </CustomButton>
      <CustomButton
       sx={{ paddingBottom: "40px" }}
       onClick={() => {
        downloadWordDocument();
       }}
       disabled={status == 1 ? false : true}
      >
       <img
        style={{ width: "100px" }}
        src={
         status == 1
          ? process.env.PUBLIC_URL + "/Images/ApprovalPage/downloadbuttonactive.png"
          : process.env.PUBLIC_URL + "/Images/ApprovalPage/downlaodbuttoninactive.png"
        }
       ></img>
      </CustomButton>
      <div
       className="feedback-icon-wrap"
       onClick={() => setOpenModal(true)}
       style={{ marginTop: "2.5px" }}
      >
       {/* <RateReviewIcon  sx={{ color: 'black', backgroundColor: 'white' }} fontSize="small" /> */}
       <VscFeedback />
       <span>Feedback</span>
      </div>
     </Stack>

     <div className="feedback-modal">
      <Modal
       // hideBackdrop
       open={openModal}
       onClose={handleCloseModal}
       aria-labelledby="child-modal-title"
       closeAfterTransition
       aria-describedby="child-modal-description"
       className="modal-container"
       sx={{ paddingLeft: "12px" }}
      >
       <Box className="model-feedback">
        <IconButton
         sx={{
          position: "relative",
          left: "100%",
          padding: "0px",
         }}
        >
         <CloseIcon
          sx={{ cursor: "pointer", marginTop: "5px", color: "#000" }}
          onClick={handleCloseModal}
         />
        </IconButton>
        {isIdNull ? (
         <Stack
          sx={{
           height: "86vh",
           justifyContent: "center",
           alignItems: "center",
          }}
         >
          <Stack
           sx={{
            height: "30%",
            background: "white",
            width: "100%",
            borderRadius: "10px",
            justifyContent: "center",
            alignItems: "center",
           }}
          >
           <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "red" }}>
            Invalid Username
           </Typography>
           <Typography>
            Please try after sometime or reach out to admin to fix this.
           </Typography>
          </Stack>
         </Stack>
        ) : (
         <>
          <div className="model-header-wrap">
           <div className="model_heading" style={{ marginBottom: "8px" }}>
            <h5 className="paramodel">Please share your valuable feedback!</h5>
           </div>
           {/* <CloseIcon
                        sx={{ cursor: "pointer" }}
                        onClick={handleCloseModal}
                      /> */}
          </div>

          <hr />
          <FeedbackForm
           handleCloseModal={handleCloseModal}
           uniqueID={uniqueID}
           isFeedbackSuccess={isFeedbackSuccess}
           setIsFeedbackSuccess={setIsFeedbackSuccess}
           campaignId={campaignId}
          />
         </>
        )}
       </Box>
      </Modal>
     </div>
    </Stack>
    {/* </Stack> */}
   </ThemeProvider>
   <div className="feedback-msg-wrap">
    {isFeedbackSuccess ? (
     <Alert
      variant="filled"
      severity="success"
      onClose={() => setIsFeedbackSuccess(null)}
      sx={{
       backgroundColor: "#ecfeec",
       color: "green",
       // boxShadow: "1px 1px 5px rgb(200, 198, 198)",
       boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
      }}
     >
      <div>
       <p
        style={{
         fontWeight: "600",
         fontSize: "16px",
         marginBottom: "10px",
        }}
       >
        Thank you for sharing your feedback!
       </p>
       <p style={{ textAlign: "center" }}>Feedback submitted successfully.</p>
      </div>
     </Alert>
    ) : (
     isFeedbackSuccess == false && (
      <Alert variant="filled" severity="error" onClose={() => setIsFeedbackSuccess(null)}>
       There was an error submitting feedback.
      </Alert>
     )
    )}
   </div>
  </>
 );
};

export default MyContentMailGeneration;
